module.exports = __webpack_public_path__ + "img/kort-7.8a7f7ae3.jpg";